import React from "react";
// import { Routes, Route } from "react-router-dom";
import { HeadProvider, Title, Meta } from "react-head";

import "./App.css";

// Sitio completo desactivado temporalmente: solo se muestra "Próximamente".
// import HomePage from "./pages/home/home.component";
// import ClientsPage from "./pages/clients/clients.component";
// import UniKPage from "./pages/unik/unik.component";
// import ContactPage from "./pages/contact/contact.component";
// import FindUsPage from "./pages/find_us/findUs.component";
// import Header from "./components/header/header.component";
// import Footer from "./components/footer/footer.component";
// import FullScreenCarrousel from "./components/full_screen_carrousel/fullScreenCarrousel.component";
import ComingSoon from "./pages/comingsoon/comingsoon.component";

const App = () => {
  return (
    <div>
      <HeadProvider>
        <Title>Krebor Technology</Title>
        <Meta property="og:title" content="Krebor Technology" />
        {/*<Meta property="og:url" content="Krebor Technology" />*/}
        <Meta name="twitter:title" content="Krebor Technology" />
      </HeadProvider>

      <ComingSoon />

      {/* Sitio completo (restaurar cuando se lance):
      <Header />
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/Uni-K" element={<UniKPage />} />
        <Route exact path="/UniK" element={<UniKPage />} />
        <Route exact path="/instalaciones" element={<ClientsPage />} />
        <Route exact path="/installations" element={<ClientsPage />} />
        <Route exact path="/encuentranos" element={<FindUsPage />} />
        <Route exact path="/findus" element={<FindUsPage />} />
        <Route exact path="/contactanos" element={<ContactPage />} />
        <Route exact path="/contact" element={<ContactPage />} />
      </Routes>
      <FullScreenCarrousel />
      <Footer />
      */}
    </div>
  );
};

export default App;
